export const INCLUDED_RENTAL_DAYS = 7;

/**
 * Returns the number of calendar days strictly AFTER deliveryDate+7, through
 * pickUpDate INCLUSIVE.  Returns 0 if pickUpDate <= deliveryDate+7.
 *
 * Every day past the included window is billed, weekends included — the dumpster
 * is on site over the weekend just as on a weekday. (Pickup still can't be
 * scheduled on a weekend; that is a separate scheduling rule.)
 *
 * Uses UTC throughout to avoid timezone-shift surprises (mirrors Go backend).
 */
export function billableExtraDays(deliveryDate: string, pickUpDate: string): number {
  const d = new Date(deliveryDate + "T00:00:00Z");
  const p = new Date(pickUpDate + "T00:00:00Z");
  if (isNaN(d.getTime()) || isNaN(p.getTime())) return 0;
  const included = new Date(d);
  included.setUTCDate(included.getUTCDate() + INCLUDED_RENTAL_DAYS);
  if (p.getTime() <= included.getTime()) return 0;
  let count = 0;
  const cur = new Date(included);
  cur.setUTCDate(cur.getUTCDate() + 1);
  while (cur.getTime() <= p.getTime()) {
    count++;
    cur.setUTCDate(cur.getUTCDate() + 1);
  }
  return count;
}

export function extraDayDescription(n: number): string {
  return `Extra rental days (${n})`;
}
